import { render, staticRenderFns } from "./KnowledgeDetail.vue?vue&type=template&id=6dd1a179&"
import script from "./KnowledgeDetail.vue?vue&type=script&lang=js&"
export * from "./KnowledgeDetail.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports